export const DEFAULT_STATUS_OPTIONS = [
    { label: 'Requested', value: 'REQUESTED' },
    { label: 'Approved', value: 'APPROVED' },
    { label: 'Sent to Cactus', value: 'SUBMITTED_TO_CACTUS' },
    { label: 'Processing', value: 'PROCESSING' },
    { label: 'Shipped', value: 'SHIPPED' },
    { label: 'Rejected', value: 'REJECTED' },
]

export const CACTUS_STATUS_OPTIONS = [
    { label: 'Received', value: 'SUBMITTED_TO_CACTUS', isDisabled: true },
    { label: 'Processing', value: 'PROCESSING' },
    { label: 'Shipped', value: 'SHIPPED' },
    { label: 'Rejected', value: 'REJECTED' },
]

export const CACTUS_FILTER_OPTIONS = [
    { label: 'Received', value: 'SUBMITTED_TO_CACTUS' },
    { label: 'Processing', value: 'PROCESSING' },
    { label: 'Shipped', value: 'SHIPPED' },
    { label: 'Rejected', value: 'REJECTED' },
]

export const SHIPPING_DESTINATION_OPTIONS = [
    { label: 'Manufacturer', value: 'MANUFACTURER' },
    { label: 'Customer', value: 'CUSTOMER' },
]

export const CACTUS_VISIBLE_STATUSES = [
    'SUBMITTED_TO_CACTUS',
    'PROCESSING',
    'SHIPPED',
    'REJECTED',
]

export const STATUS_SEQUENCE = [
    'REQUESTED',
    'APPROVED',
    'SUBMITTED_TO_CACTUS',
    'PROCESSING',
    'SHIPPED',
    'REJECTED',
]

export const ITEMS_PER_PAGE = 10
